import React from 'react'
import { useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import { IconName } from '@fortawesome/fontawesome-svg-core'

// evertel
import { PageBody, Row, Card, CardBody, Icon, Text } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { CurrentUserController } from '@evertel/blue-user'
import { DocumentsTabs } from '../elements'

const OPTIONS = [
    {
        icon: 'table-list',
        title: 'Template builder',
        description: 'Create your own custom form template from scratch by choosing from a wide variety of components.',
        path: '/everdocs/schema/add'
    },
    {
        icon: 'book-open',
        title: 'Evertel Catalog',
        description: 'Choose a pre-designed template from the catelog to save time. You can use it as is or as a base to customize it.',
        path: '/everdocs/schema/templates'
    }
]

const NewDocumentTemplate: React.FC = observer(() => {

    const navigate = useNavigate()
    const currentUserController = useService(CurrentUserController, [])

    const onKeyDown = (e: React.KeyboardEvent, path: string) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            navigate(path)
        }
    }

    return (
        <PageBody
            flush
            className="documents-page">
            <div className="px-4 pt-4">
                {currentUserController.canManage && <DocumentsTabs />}
                <Text tag="h3">
                    Select New Template Type
                </Text>
                <Text
                    tag="p"
                    color="muted">
                    You can build your own from scratch, or select from the Evertel Catalog. Click on your preferred option to start.
                </Text>
            </div>
            <Row className="px-4 pb-4 flex-wrap">
                {OPTIONS.map((option) =>
                    <Card
                        key={option.path}
                        role="button"
                        tabIndex={0}
                        className="template-select-card me-3 mb-3"
                        onClick={() => navigate(option.path)}
                        onKeyDown={(e: React.KeyboardEvent) => onKeyDown(e, option.path)}>
                        <CardBody>
                            <Row
                                valign="center"
                                className="mb-2">
                                <div
                                    className={`mb-2 mb-md-0 d-flex align-items-center justify-content-center text-bg-primary rounded-3`}
                                    style={{ width: '35px', height: '35px' }}
                                >
                                    <Icon
                                        color="tertiary-bg"
                                        name={option.icon as IconName}
                                        size={22}
                                    />

                                </div>
                                <strong
                                    className="mb-0 ms-2">
                                    {option.title}
                                </strong>
                            </Row>
                            <Text
                                color="muted"
                                size={13}>
                                {option.description}
                            </Text>
                        </CardBody>
                    </Card>
                )}
            </Row>
        </PageBody>
    )
})

export { NewDocumentTemplate }
